module.exports = __webpack_public_path__ + "img/onlineOffline-banner-1.756a2c9c.png";